import { DatePipe } from '@angular/common';
import { TranslationService } from 'projects/dop-core/src/public-api';
import { OrderStatus } from 'src/app/shared/models/my-orders/order-status.model';
import { ScheduleOrderStatus } from 'src/app/shared/models/my-orders/schedule-order-status.model';

// to split the field incase there is subfields coming from the object to display table
export default class ResolveFieldData {
    static resolve(data: any, field: string): any {
        if (data && field) {
            if (field.indexOf('.') === -1) {
                if (field === 'status' && data[field] === ScheduleOrderStatus[1].toString()) {
                    return TranslationService.translate('vbeiActive');
                } else if (field === 'status' && data[field] === ScheduleOrderStatus[2].toString()) {
                    return TranslationService.translate('vbeiInactive');
                }
                if (data[field] instanceof Date) {
                    const datePipe = new DatePipe(sessionStorage.getItem('LanguageCode'));
                    return datePipe.transform(data[field], 'short');
                }
                if (data[field] == 'Pending') {
                    return TranslationService.translate(OrderStatus.PendingState);
                }
                return data[field];
            } else {
                const fields: string[] = field.split('.');
                let value = data;
                for (let i = 0, len = fields.length; i < len; ++i) {
                    if (value == null) {
                        return null;
                    }
                    value = value[fields[i]];
                }
                return value;
            }
        } else {
            return null;
        }
    }
}
